import { atom } from 'recoil';

import { PickMealPoint } from '~/types/cart';

const remotePickMealPoint = atom<PickMealPoint | null>({
  key: 'remotePickMealPoint',
  default: null,
});

export default remotePickMealPoint;
